export default __webpack_public_path__ + "static/object-tile-smaller-dont-4782b73cd2751eb3d8c5794203188dd3.png";